import { Status, useSession } from '@lendi/lala-react';
import { Application, MultiNavbar, SimpleNavbar } from '@lendi/navbar';
import * as qs from 'qs';
import React from 'react';
import { HeroPanel } from '../HeroPanel';

export interface HeaderProps {
  isArticlePage: boolean;
}

export const Header = ({ isArticlePage }: HeaderProps) => {
  const session = useSession();
  const isAuthenticated = session.status === Status.Authenticated;

  return <HeaderInside logout={session.logout} isAuthenticated={isAuthenticated} isArticlePage={isArticlePage} />;
};

interface HeaderInsideState {
  rendered: Boolean;
}

interface HeaderInsideProps {
  application?: Application;
  isAuthenticated: boolean;
  logout?: () => void;
  isArticlePage: Boolean;
}

class HeaderInside extends React.Component<HeaderInsideProps, HeaderInsideState> {
  constructor(props: any) {
    super(props);
    this.state = {
      rendered: false,
    };
  }

  componentDidMount() {
    this.setState({ rendered: true });
  }

  render() {
    if (!this.state.rendered) return null;

    const { logout, isArticlePage } = this.props;

    let hasUtm: Boolean | undefined;
    const queryString = qs.parse(location && location.search, { ignoreQueryPrefix: true });
    // Spoke with Freya (Marketing) and utm_campaign is a property
    // that will always be present if a user comes from an ad.
    hasUtm = !!queryString.utm_campaign;

    const AppropriateNavbar = hasUtm ? (
      <SimpleNavbar
        useTransparent={false}
        onLogout={logout}
        homeURL={'/'}
        continueURL={'/dashboard/applications/'}
        showContinueAction={true}
      />
    ) : (
      <MultiNavbar
        useTransparent={false}
        homeURL={'/'}
        onLogout={logout}
        continueURL={'/dashboard/applications/'}
        showContinueAction={true}
      />
    );

    return isArticlePage ? AppropriateNavbar : <HeroPanel>{AppropriateNavbar}</HeroPanel>;
  }
}
